import React, { Fragment, useState } from "react";
import { isMobile } from "react-device-detect";
import { Dialog } from "@material-ui/core";
import UtilizationFormData from "./UtilizationFormData";
import { DownloadSvSampleFile } from "../apiServices";
import { convertFilterObject, removeEmptyKey, permissionCheckFnforCamo, getLocalStorageInfo } from "../../../../utils";
import CamoCTA from "../../../../shared_elements/components/cta/CamoCTA";

const UtilizationSearchBar = ({ applyingFilter, tabIndex, pageLoader, props, searchData, fileUploadData, importFile, exportReportFn, currentRecordPerPage, uuid, getResponseBack, engineType, assetsDetail, basicDetails, techspecData, utilApprovalflow }) => {
	const [open, setOpen] = useState(false);
	const [formTitle, setFormTitle] = useState("");
	const [actionType, setActionType] = useState("");

	const isSecurityGroup29 = !!getLocalStorageInfo()?.user?.security_groups?.find(item => item?.id === 29);

	const addNewTask = () => {
		setOpen(true);
		setFormTitle("Utilization");
		setActionType("add");
	};

	const importFileFunc = (e) => {
		const files = e.target.files;
		const fileType = files[0].type;
		let formData = new FormData();
		for (let i = 0; i < files.length; i++) {
			formData.append('file', files[i]);
			formData.append('redirect_url', window?.location?.href);
		}
		if (fileType.endsWith("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
			importFile(formData, props, true);
		} else {
			importFile(formData, props, false);
		}
		e.target.value = null;
	};

	const filterParams = convertFilterObject(removeEmptyKey(applyingFilter));

	return (
		<Fragment>
			<div id="AmpSearchBar" className="utilization-approval">
				<CamoCTA
					searchPlaceholder="Search By Location(A/C Reg) Location (Country) Reason Of Removal"
					onSearch={(value) => searchData({ target: { value } })}
					permissionCheck={!permissionCheckFnforCamo({ primaryKey: "utilization", keyIndex: "C" }) || window?.location?.search.includes('archived-assets')}
					addLabel="ADD UTILIZATION"
					onAddFn={addNewTask}
					onImportFn={isSecurityGroup29 ? importFileFunc : undefined}
					exportMenu={{
						exportReportFn: exportReportFn,
						files: [
							{ title: 'PDF', extension: 'pdf', key: '' },
							{ title: 'EXCEL', extension: 'xlsx', key: '' },
						],
					}}
					downloadSampleMenu={isSecurityGroup29 ? {
						exportReportFn: (file) => DownloadSvSampleFile(
							{ download: file.extension, ...filterParams, asset_type: tabIndex },
							pageLoader, props, basicDetails
						),
						files: [
							{ title: 'DOWNLOAD SAMPLE', extension: 'xlsx', key: '' },
						],
					} : undefined}
				/>
				<Dialog open={open} style={{ height: isMobile && "650px" }}>
					<UtilizationFormData
						formTitle={formTitle}
						closeAddForm={() => setOpen(false)}
						props={props}
						actionType={actionType}
						fileUploadData={fileUploadData}
						currentRecordPerPage={currentRecordPerPage}
						uuid={uuid}
						getResponseBack={() => getResponseBack()}
						engineType={engineType}
						assetsDetail={assetsDetail}
						basicDetails={basicDetails}
						techspecData={techspecData}
						utilApprovalflow={utilApprovalflow}
					/>
				</Dialog>
			</div>
		</Fragment>
	);
};

export default UtilizationSearchBar;
